import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/app';

import './css/normalize.css';
import './css/main.css';

import './fonts/material-icons/material-icons.css';
import './css/app.css';

import queryString from 'query-string';
import globalizacao from './js/escolha/globalizacao';
import traducoes from './js/modules/traducoes';

globalizacao.init(traducoes);


const parsed = queryString.parse(window.location.search);
if (parsed && parsed.lang) {
    window.localStorage["site-lang"] = parsed.lang;
}

var lang = window.localStorage["site-lang"];

if (lang) {
    globalizacao.setLinguaDoUsuario(lang);
}

console.log("Escolha Tecnologia.");
ReactDOM.render(<App />, document.getElementById('root'));

